<mat-card appearance="outlined" class="linkexpire-container">
  <mat-card-content>
    <p>The link has expired. Please get in touch with the sender of the link!</p>
  </mat-card-content>
</mat-card>
